import * as React from 'react';
import { Container } from 'reactstrap';

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        <div>
            {props.children}
        </div>
    </React.Fragment>
);
